export const api = {
  auth: {
    signUp: 'api/v1/vendor/accounts/register/',
    signIn: 'api/v1/accounts/login/',
    logout: 'api/v1/accounts/logout/',
    loggedInUser: 'api/v1/accounts/user/',
    verifyEmail: 'api/v1/vendor/accounts/verify-otp/',
    resendEmail: 'api/v1/vendor/accounts/regenerate-otp/',
    setPassword: 'api/v1/vendor/accounts/complete-registration/',
    updateUser: 'api/v1/accounts/user/pk/',
    sendResetPasswordEmail: 'api/v1/accounts/send_reset_password_email/',
    resetPassword: 'api/v1/accounts/reset_password/',
  },
  onBoarding: 'api/v1/vendor/accounts/on-boarding/',
  product: {
    categories: 'api/v1/catalog/vendor/categories/',
    subCategories: 'api/v1/catalog/vendor/categories/id/subcategories/',
    brands: 'api/v1/catalog/vendor/brands/',
    fabrics: 'api/v1/catalog/vendor/fabrics/',
    colors: 'api/v1/catalog/vendor/colors/',
    sizes: 'api/v1/catalog/vendor/sizes/',
    collection: 'api/v1/catalog/product/collections/',
    addProduct: 'catalog/api/v1/vendor/product/',
    editProduct: 'catalog/api/v1/vendor/product/',
    removeVariant: 'api/v1/catalog/vendor/product-variants/delete/',
    removeVariantSize: 'api/v1/catalog/vendor/product-variants/delete/',
    removeVariantImage: '/api/v1/catalog/vendor/variant-image/delete/',
    addOnFields: 'api/v1/catalog/add-on/',
    addOnFieldsByCategory: 'catalog/api/v1/vendor/add-ons/:category_id/',
    getCurrency: 'api/v1/catalog/vendor/get-currency/',
    styleFields: 'api/v1/catalog/style-field',
    measurementFields: 'api/v1/core/measurement-list/',
    sizeGuide: 'api/v1/catalog/vendor/size-guide/',
  },
  manageProduct: {
    filterCategories: 'api/v1/catalog/vendor/categories/',
    filterSubCategories: 'api/v1/catalog/vendor/categories/:id/subcategories/',
    list: `catalog/api/v1/vendor/product/?page_size=10`,
    product_detail: `catalog/api/v1/vendor/product/:id`,
    delete: `catalog/api/v1/vendor/product/:id/`,
    reStock: 'api/v1/catalog/vendor/product-variants/restock/:id/',
    addonsRestock: '/catalog/api/v2/vendor/add-on/restock',
    count: 'api/v1/catalog/vendor/manage-product/count/',
    addonCount: 'api/v1/catalog/vendor/manage-product/count/',
    variants: 'catalog/api/v1/vendor/variants/:product_id/',
    addOnsList: 'catalog/api/v1/vendor/product/?page_size=10',
    deleteAddOn: 'catalog/api/v2/vendor/add-on/:id/',
    addOnDetail: 'catalog/api/v1/vendor/product/:id/',
  },
  reviews: {
    list_by_product: 'api/v1/product/review/vendor/product/:id/',
    customer_reviews: 'api/v1/catalog/vendor/product/reviews/list/',
    delete: '/api/v1/product/review/vendor/:id/delete/',
    reports_by_review: '/api/v1/product/review/vendor/:id/reports/',
    delete_report: '/api/v1/product/review/vendor/report/delete/:id/',
    hide_report: (id: string | number) => `/api/v1/catalog/vendor/hide/review/${id}/`,
    unhide_report: (id: string | number) => `/api/v1/catalog/vendor/un-hide/review/${id}/`,

    admin: {
      list: '/api/v1/vendor/testimonials/admin/vendor-testimonials/',
      create: '/api/v1/vendor/testimonials/admin/vendor-testimonials/',
      get: (id: string | number) => `/api/v1/vendor/testimonials/admin/vendor-testimonials/${id}/`,
      patch: (id: string | number) =>
        `/api/v1/vendor/testimonials/admin/vendor-testimonials/${id}/`,
      delete: (id: string | number) =>
        `/api/v1/vendor/testimonials/admin/vendor-testimonials/${id}/`,
    },
  },
  returnProduct: {
    list: `api/v1/catalog/vendor/order-returns/?page_size=10`,
    approve_reject: `api/v1/catalog/vendor/order-returns/:id/approve-reject/`,
    order_received: `api/v1/order/order-received/`,
    count: 'api/v1/catalog/vendor/return-order/count/',
  },
  order: {
    allOrder: 'api/v1/order/vendor/tracking/',
    moveStatus: 'api/v1/order/move/',
    statusCount: 'api/v1/order/status-count/',
    uploadMaintenanceImage: 'api/v1/order/image/upload/',
    maintenanceImages: (orderId: string) =>
      `/api/v1/order/image/upload/images-by-order/${orderId}/`,
    maintenanceImagesByTransaction: (billId: string) =>
      `/api/v1/order/image/upload/images-by-transaction/${billId}/`,
  },

  orderTracking: {
    list: 'api/v1/order/tracking/',
    cancel_order: 'api/v1/order/cancel/',
    cancel_reasons: 'api/v1/order/cancel/reason/',
    groupList: '/payments/api/v1/paypal/vendor/history/',
  },
  coupon: {
    list: 'api/v1/checkout/vendor/coupons/?page_size=10',
    create: 'api/v1/checkout/vendor/coupons/',
    delete: 'api/v1/checkout/vendor/coupons/:id/',
  },
  learning: {
    list: 'api/v1/vendor/testimonials/learning',
  },
  chat: {
    url: 'api/v1/chat/',
  },
  message: {
    list: 'api/v1/chat/',
    detail: 'api/v1/chat',
  },
  userManagement: {
    list: 'api/v1/vendor/accounts/role-permissions/?page_size=10',
    role_titles: 'api/v1/vendor/accounts/titles/',
    roles: 'api/v1/vendor/accounts/roles/',
    create_user: 'api/v1/vendor/accounts/role-permissions/',
    delete_user: 'api/v1/vendor/accounts/delete-role-permissions/:id/',
    update_user: 'api/v1/vendor/accounts/update-role-permissions/:id/',
  },
  account: {
    details: 'api/v1/vendor/accounts/information/',
    delete: 'api/v1/vendor/accounts/delete/',
    changePassword: 'api/v1/vendor/accounts/change-password/',
  },
  store: {
    details: 'api/v1/vendor/accounts/store/',
  },
  dashboard: {
    salesSummary: 'api/v1/best_seller/sales-metrics/',
    totalOrder: 'api/v1/best_seller/category-sales/',
    totalSell: 'api/v1/best_seller/category-sales-percent/',
    topSell: 'api/v1/best_seller/best-selling-metrics/',
    recentOrder: 'api/v1/order/vendor/tracking/',
    pendingOrder: 'api/v1/catalog/vendor/pending-orders/',
  },
  notifications: {
    list: 'api/v1/notification/',
    patch_latest_notification: 'api/v1/notification/',
    mark_as_all_read: 'api/v1/notification/mark-all-as-read/',
  },
  core: {
    countries: 'api/v1/core/countries/',
    genders: 'api/v1/core/genders/',
  },
  payment: {
    vendorHistory: 'api/v1/vendor/accounts/payment/history/',
    customerHistory: 'api/v1/vendor/accounts/customer/payment/history/',
    history: 'payments/api/v1/paypal/vendor/history/',
    remainingPayment: 'api/v1/vendor/accounts/remaining-payment/',
  },
  commission: 'api/v1/information/commission-range/',
  compressImage: '/api/v1/core/compress-image/',
};

export const serverUrl = {
  client: 'https://kurtasari.com/',
  server: 'https://api.kurtasari.com/',
};
